<template>
<div class="manageadr-box">
     <!-- 导航栏 -->
        <nav-Bar
        leftTitle="管理地址">
        </nav-Bar>
    <!-- 无地址背景图 -->
    <div class="bg-box" v-show="total==0">
        <div class="bg"></div>
        <p>您还没有添加任何地址</p>
    </div>
    <!-- 地址列表 -->
    <van-panel v-for="(item,i) in rowsList" :key=item.id :title="item.recipient" :desc="item.address" :status="item.phone">
        <div slot="header" class="adrlist-header">
            <div>
                <div class="header-name-tel">
                    <span>{{item.recipient}}</span>
                    <span>{{item.phone}}</span>
                </div>
                <div class="header-adr-text">{{item.address}}</div>
            </div>
            <van-radio-group v-model="radio">
                <van-radio @click="slecti(i)" :name="i" checked-color="#1750E5" ></van-radio>
            </van-radio-group>
        </div>
    </van-panel>
     <!-- 添加地址按钮 -->
        <div class="footer-btns">
         <van-button type="primary" color="#3062E9" size="large" class="myinvoice-btn" @click="toAddAdr">添加地址</van-button>
         <div class="line"></div>
         <van-button type="primary" color="#3062E9" size="large" class="addheader-btn" @click="sureSubmit(rowsList[radio])">确定</van-button>
    </div>
</div>
</template>
<script>
import navBar from '@/components/navBar/navbar'
export default {
    components: {navBar}, 
    data(){
        return{
             radio: sessionStorage.getItem('selectAdrress')?Number(sessionStorage.getItem('selectAdrress')):0,
            //  地址总条数
             total:0,
            //  地址列表
             rowsList:[]
        }
    },
    created(){
        this.getAdrList();
    },
    methods:{
        // 获取地址相关数据
     async   getAdrList(){
         console.log(this.radio)
         const {data:res}=await  this.$http.post(`${this.lanUrl}/EcConsumerInfo/getReceiptAddressPageList?customerId=${this.$store.state.customerId}`,{
            "currentPage": 1,
            "pageSize": 100,
            "paramsMap": {},
            "sortName": "createTime",
            "sortType": "desc"
            });
           if(res.success!==true){
               return false;
           }
           this.total=res.total;
           this.rowsList=res.rows;
           console.log(res); 
           console.log(this.rowsList);
            // 置顶排序
            this.rowsList=   res.rows.sort(function(a,b){
                return (b.status-a.status)
            })
            // 置顶索引
            // this.radio=  this.rowsList.findIndex(item=>{
            // return    item.status===1;
            // })
        },
         // 设为默认地址
        async  setDefaultAdr(item,i){
            console.log(item)
           const res=  await  this.$http.post(`${this.lanUrl}/EcConsumerInfo/topEcReceiptAddress`,item);
            console.log(res)
            this.$store.commit('applyInvoiceAdr',JSON.stringify(item))
            this.getAdrList()
        },
        // 添加
        toAddAdr(){   
            this.$router.push('/addadr')
        },
        // 点击确认按钮
        sureSubmit(item){
            this.$store.commit('applyInvoiceAdr',JSON.stringify(item));
            this.$router.go(-1);
        },
        slecti(i){
            sessionStorage.setItem('selectAdrress',i)
        }
    }
}
</script>
<style lang="less" scoped>
.manageadr-box{
    height: 100%;
    // 地址列表
    .van-panel{
        margin-top: 7px;
        // padding: 15px 20px;
        font-size: 14px;
        // 头部区域
        .adrlist-header{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .header-name-tel{
                padding: 10px 16px 0;
                color: #333;
                span{
                    padding-right: 10px;
                    
                }
                :nth-child(2){
                        color: #ccc;
                        font-size: 12px;
                    }
            }
            .header-adr-text{
                padding: 10px 16px;
                font-size: 12px;
                // transform: scale(0.9);
                color: #B7B7B7;
            } 
        }
        .van-radio-group{
            margin-right: 16px;
        }
       
    }
    //添加地址、确定按钮
     .footer-btns{
         position: fixed;
         display: flex;
         width: 100%;
         bottom: 0!important;
         .line{
             width: 1px;
             background-color:#5881ED;
         }
    }
    .van-hairline--top::after{
        border: 0;
    }
}
</style>